import { DiagramWithChildrenDto } from '../../../../app/api';
import { useCurrentUser } from '../../../authentication/useCurrentUser';
import { isDiagramOwner } from '../util';

export function useIsOwner(diagram?: Pick<DiagramWithChildrenDto, 'ownerId'>) {
  const user = useCurrentUser();
  return !!diagram && isDiagramOwner(diagram, user);
}
